import { render } from "./Xing.vue?vue&type=template&id=477c877c"
import script from "./Xing.vue?vue&type=script&lang=js"
export * from "./Xing.vue?vue&type=script&lang=js"
script.render = render

export default script